import { isEmpty } from 'lodash'
import { colors } from '@material-ui/core'

import constants from 'constants/index'

const readingTypeTranslation = (kind) => {
  return (
    constants.cookies.consent.READING_TYPE_TRANSLATION[kind] || 'indeferido'
  )
}

const detectDevice = (userAgent) => {
  const {
    DEVICE_LABELS,
    DEVICE_TABLET_REGEX,
    DEVICE_MOBILE_REGEX,
    DEVICE_DESKTOP_REGEX,
  } = constants.cookies.consent
  const userAgents = (userAgent || '').trim()

  if (isEmpty(userAgents)) return DEVICE_LABELS.unidentified
  if (DEVICE_TABLET_REGEX.test(userAgents)) return DEVICE_LABELS.tablet
  if (DEVICE_MOBILE_REGEX.test(userAgents)) return DEVICE_LABELS.mobile
  if (DEVICE_DESKTOP_REGEX.test(userAgents)) return DEVICE_LABELS.desktop

  return DEVICE_LABELS.unidentified
}

const chipStatusColor = (kind) => {
  return (
    (kind && constants.cookies.consent.STATUS_CHIP_COLOR[kind]) ||
    colors.grey[300]
  )
}

const chipFontStatusColor = (kind) => {
  return (
    (kind && constants.cookies.consent.STATUS_CHIP_FONT_COLOR[kind]) ||
    colors.grey[800]
  )
}

const formatStatsCards = (statsData) => {
  const { STATS_CARDS_CONFIG } = constants.cookies.consent

  return STATS_CARDS_CONFIG.map((config) => {
    const value = statsData[config.key] || 0

    return {
      icon: config.icon,
      label: config.label,
      value,
      backgroundColor: config.backgroundColor,
      kind: config.kind,
    }
  })
}

export default {
  readingTypeTranslation,
  detectDevice,
  chipStatusColor,
  chipFontStatusColor,
  formatStatsCards,
}
